const locale = {
	// #region Logs fields
	LOGS_COLUMN_TYPE: 'Log type',
	LOGS_COLUMN_ITEM_TABLE: 'Item type',
	LOGS_COLUMN_ITEM_TITLE: 'Item',
	LOGS_COLUMN_USER: 'User',
	LOGS_COLUMN_DATE: 'Date',
	LOGS_COLUMN_LOGIN_DATE: 'Login date',
	LOGS_COLUMN_ITEM_PAYLOAD: 'Payload'
	// #endregion
};

export default locale;
